<template>
  <User state="edit" />
</template>

<script>
import User from '@/components/Settings/UserOperations/User'
export default {
    components: {
        User
    }
}
</script>

<style>

</style>